import { render, staticRenderFns } from "./editPsg.vue?vue&type=template&id=327a9afc&scoped=true&"
import script from "./editPsg.vue?vue&type=script&lang=js&"
export * from "./editPsg.vue?vue&type=script&lang=js&"
import style0 from "./editPsg.vue?vue&type=style&index=0&id=327a9afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a9afc",
  null
  
)

export default component.exports